import Alert from 'react-s-alert';
import { I18n } from 'react-redux-i18n-lite';
import { REDUCER } from '../reducers/reducersConst';
import { getSkinFromStorageOrDefault } from '../shared';

/**
 * MESSAGE ACTIONS
 */
export let setInfoMessages = (messages = []) => {
  return {
    type: REDUCER.MESSAGE.SET_INFO_MESSAGES,
    messages
  };
};

export let setErrorMessages = (messages = []) => {
  return {
    type: REDUCER.MESSAGE.SET_ERROR_MESSAGES,
    messages
  };
};

export let setSuccessMessages = (messages = []) => {
  return {
    type: REDUCER.MESSAGE.SET_SUCCESS_MESSAGES,
    messages
  };
};

export let setWarningMessages = (messages = []) => {
  return {
    type: REDUCER.MESSAGE.SET_WARNING_MESSAGES,
    messages
  };
};

/**
 * Info
 * @param message
 */
export let info = (message = '') => {
  return (dispatch, getState) => {
    if (message) {
      let messages = getState().messageAlert.info;
      messages.push(message);
      dispatch(setInfoMessages(messages));
      dispatch(showMessages());
    }
  };
};

/**
 * Error
 * @param message
 */
export let error = (message = '') => {
  return (dispatch, getState) => {
    if (message) {
      let messages = getState().messageAlert.error;
      messages.push(message);
      dispatch(setErrorMessages(messages));
      dispatch(showMessages());
    }
  };
};

/**
 * Success
 * @param message
 */
export let success = (message = '') => {
  return (dispatch, getState) => {
    if (message) {
      let messages = getState().messageAlert.success;
      messages.push(message);
      dispatch(setSuccessMessages(messages));
      dispatch(showMessages());
    }
  };
};

/**
 * Warning
 * @param message
 * @returns {function(*, *)}
 */
export let warning = (message = '') => {
  return (dispatch, getState) => {
    if (message) {
      let messages = getState().messageAlert.warning;
      messages.push(message);
      dispatch(setWarningMessages(messages));
      dispatch(showMessages());
    }
  };
};

export let notImplementedYet = () => {
  return (dispatch, getState) => {
    let messages = getState().messageAlert.info;
    messages.push(I18n.t('common.notImplemented'));
    dispatch(setInfoMessages(messages));
    dispatch(showMessages());
  };
};

/**
 * Show Messages
 * @returns {function(*, *)}
 */
export let showMessages = () => {
  return (dispatch, getState) => {
    let state = getState();
    let localStorageTheme = getSkinFromStorageOrDefault();
    let iconsInLocalStore = localStorageTheme.images && localStorageTheme.images.icons;
    let storedIcons = iconsInLocalStore ? localStorageTheme.images.icons : {};

    // Info
    let infoMessages = state.messageAlert.info;
    let infoImage = state.theme.images ? state.theme.images.icons.alertSuccess : '';
    let avatarImg = storedIcons.alertSuccess ? storedIcons.alertSuccess : infoImage;
    if (infoMessages.length > 0) {
      infoMessages.forEach(message => {
        Alert.info(message, {
          customFields: {
            avatarImg
          },
          position: 'top-right'
        });
      });
      dispatch(setInfoMessages());
    }

    // Error
    let errorMessages = state.messageAlert.error;
    let errorImg = state.theme.images ? state.theme.images.icons.alertError : '';
    avatarImg = storedIcons.alertError ? storedIcons.alertError : errorImg;
    if (errorMessages.length > 0) {
      errorMessages.forEach(message => {
        Alert.error(message, {
          customFields: {
            avatarImg
          },
          position: 'top-right'
        });
      });
      dispatch(setErrorMessages());
    }

    // Success
    let successMessages = state.messageAlert.success;
    let successImg = state.theme.images ? state.theme.images.icons.alertSuccess : '';
    avatarImg = storedIcons.alertSuccess ? storedIcons.alertSuccess : successImg;
    if (successMessages.length > 0) {
      successMessages.forEach(message => {
        Alert.success(message, {
          customFields: {
            avatarImg
          },
          position: 'top-right'
        });
      });
      dispatch(setSuccessMessages());
    }

    // Warning
    let warningMessages = state.messageAlert.warning;
    let warningImg = state.theme.images ? state.theme.images.icons.alertWarning : '';
    avatarImg = storedIcons.alertWarning ? storedIcons.alertWarning : warningImg;
    if (warningMessages.length > 0) {
      warningMessages.forEach(message => {
        Alert.warning(message, {
          customFields: {
            avatarImg
          },
          position: 'top-right',
          zIndex: 1500
        });
      });
      dispatch(setWarningMessages());
    }
  };
};
